const Spinner = () => {
  return (
    <div className="flex items-center justify-center min-h-screen">
      <div
        className="w-12 h-12 border-4 border-[#998147] border-t-transparent rounded-full animate-spin"
        role="status"
        aria-label="Loading"
      ></div>
      <h1 className='pl-4 text-xl sm:text-xl'> Loading ...</h1>
    </div>
  );
};

export default Spinner;
